import React, { useState, useEffect } from "react"
import ct from "../img/logo_CircularTool.png";
//import { Link } from "react-router-dom";
//import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components'
import { FaBars } from "react-icons/fa";
import UserinfoHeader from "./UserinfoHeader";
import Storage from './utils/Storage';
//import useStoreEventi from './useStoreEventi'
import logo from '../img/logo.png';
import service from "../services/anagrafica/Accessoutenteservice";
//import BreadArea from './breadcrumbs/BreadArea'
/*
const Container = styled.header`
//height: 4rem;
position: fixed;
z-index: 500;
top: 0;
left: 0rem;
width: 100%;

`*/
const fontSizeBase = 100;
function Header({ wSide, sidebarshow, onToggleSidebar }) {

    const [offset, setOffset] = useState(null);
    const setScroll = () => {
        setOffset(window.scrollY !== 0);
    };
    useEffect(() => {
        window.addEventListener("scroll", setScroll);
        return () => {
            window.removeEventListener("scroll", setScroll);
        };
    }, []);


    //   const [fontSize, setFontSize] = useState(Storage.getItem('fontsize') || fontSizeBase);

    //const storeEventi = useStoreEventi();
    /*
        const handleFontSizeBase = () =>
            aggiornaFontSize(fontSizeBase);
    
    
        const handleFontSizeBigger = () =>
            aggiornaFontSize(parseInt(fontSize) + 10);
    
    
        const handleFontSizeSmaller = () =>
            aggiornaFontSize(fontSize - 10);
    
        const aggiornaFontSize = v => {
            const vMin = 50;
            const vMax = 200;
            const v0 = v < vMin ? vMin : (v > vMax ? vMax : v);
            Storage.setItem('fontsize', v0);
            setFontSize(v0);
            const { emit, types } = storeEventi;
            emit({
                type: types.update,
                entita: 'ui_fontsize',
                fontSize: v0,
            })
        }
    */
    const handleSidebar = () =>
        onToggleSidebar && onToggleSidebar();

    const limitazioneLingua = Storage.getItem('limitazioneLingua') === '1';

    const isSuperUser = Storage.getItem('user_level') === 'S';
    const marginRight = isSuperUser || limitazioneLingua ? undefined : '12rem';


    const handleLogout = () => {
        service.logout();

        //access esiste solo in developmente
        Storage.removeItem('access_token');
        Storage.removeItem('refresh_token');
        Storage.removeItem('current_user');
        window.location.reload();
    }

    const GlobalStyle = createGlobalStyle`
html {
    font-size: ${fontSizeBase}%};
}
`
    //    const classNameRotate = sidebarshow ? "fa-rotate-180" : "";
    return (
        <>
            <GlobalStyle />
            <div style={{
                backgroundColor: !offset ? 'transparent' : '#fff',
                transition: 'background-color .3s',
                position: 'fixed',
                zIndex: 500,
                top: 0,
                left: 0,
                width: '100%',
            }}>
                <div className="border-bottom headerArea noprintable">
                    <div className="logoArea position-relative noprintable" style={{ float: 'left', width: wSide + 'rem' }}>

                        {!sidebarshow && (
                            <div className="position-absolute" style={{ left: '1.5rem', top: '0.6rem' }}>
                                <span onClick={handleSidebar} className="cursor-pointer"  >
                                    <FaBars />
                                </span>
                            </div>
                        )}
                        <span className="cursor-pointer" onClick={() => window.location.href = "/"} >
                            <div className="text-center pl-3 pr-3 pb-3 pt-4 ml-5">
                                <img src={logo} alt="Matrec" style={{
                                    width: '10rem',
                                    textAlign: 'center',
                                    position: 'relative',
                                    left: !sidebarshow ? '1.5rem' : 0,
                                }} />
                            </div>
                        </span>
                    </div>
                    <div className="head" style={{ marginLeft: wSide + 'rem' }}>
                        <div className="d-flex justify-content-between align-items-center" style={{ height: '4rem' }}>


                            {/*
                                
                                {' '}
                                <div className="btn-group" role="group" aria-label="Grandezza carattere">
                                    <button type="button" className="btn btn-secondary font-italic" onClick={handleFontSizeSmaller}>A</button>
                                    <button type="button" className="btn btn-secondary" onClick={handleFontSizeBase}>A</button>
                                    <button type="button" className="btn btn-secondary font-weight-bold" onClick={handleFontSizeBigger}>A</button>
                            </div>
                            <div className="pl-5 d-flex align-items-center">
                                <span className="headertext">Circular</span>
                                <span className="headertext text-primary">Tool</span>
                            </div>*/}

                            <div className="text-center" style={{ flexGrow: 1 }}>
                                <img src={ct} alt="Circular Tool" style={{
                                    width: offset ? '14rem' : '16rem',
                                    transition: 'width .3s',
                                }} />
                            </div>
                            <div className="text-right">
                                <div className="d-flex align-items-center" style={{ marginRight }}>
                                    <UserinfoHeader />
                                    <button className="btn btn-info pt-0 pb-0 font-weight-semibold rotondo mt-3 mb-3" style={{ fontSize: '80%', marginRight: '2rem' }} onClick={handleLogout}>LOGOUT</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Header;